"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
angular.module('callX', [
    'ngAnimate',
    'ngAria',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'ui.router',
    'ui.bootstrap',
    'ui.utils',
    'ui.load',
    'ui.jq',
    'oc.lazyLoad',
    'ngMaterial',
    'toaster',
    'ui.select',
    'ngAudio',
    'satellizer',
    'angularUtils.directives.dirPagination',
    'toggle-switch',
    'timer'
]);
